import { Download, FilterAlt, WidthFull } from "@mui/icons-material";
import { IconButton, Menu, Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { FormikValues, useFormikContext } from "formik";
import { FC, MouseEvent, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Button from "../../../common/Button";
import DropdownField from "../../../common/form/dropdown/DropdownField";

import patientService from "../../../../services/patient";

import { districts, fileExportDropDown } from "../../../../constants/patient";
import { RootState } from "../../../../redux/store";
import { assetUrl } from "../patientDialog/ImageAsset";
import { patientSx } from "../styles";
import styles from "../styles.module.scss";

const DownloadPopup: FC = (props) => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const { values, setValues, setFieldValue } = useFormikContext<FormikValues>();
  const { role } = useSelector(
    (state: RootState) => state.auth.profileData.user
  );

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value);
  };

  const downloadCSV = async () => {
    try {
      const response = await patientService.report(
        values?.csvType,
        new Date(values?.fromDateCSV).toISOString().substring(0, 10),
        new Date(values?.toDateCSV).toISOString().substring(0, 10)
      );
      if (response.data.data) {
        const link = document.createElement("a");
        link.href = assetUrl(response.data.data);
        link.target = "_blank";
        link.download = response.data.data.split("/").pop();
        link.click();

        URL.revokeObjectURL(link.href);
        link.remove();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    setFieldValue("csvType", fileExportDropDown[role][0]._id);
    setFieldValue("fromDateCSV", "2023-02-23");
    setFieldValue("toDateCSV", new Date().toISOString().substring(0, 10));
  }, []);

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  return (
    <>
      {/* <p></p> */}
      <Box>
        <Tooltip title="Download">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Download />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Box sx={{ maxWidth: "400px" }}>
          <Typography sx={{ padding: "10px 20px" }}>
            <b>Download Option</b>
          </Typography>
          <hr />
          <Box sx={{ padding: "10px 20px" }}>
            <Typography sx={patientSx.filterSpan}>Raised Date</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", margin: "0 -5px" }}>
              <Box
                sx={{
                  width: "50%",
                  padding: "0 5px",
                  "@media (max-width: 767px)": {
                    width: "100%",
                    padding: "0",
                  },
                }}
              >
                <Typography sx={patientSx.filterSpan}>From</Typography>
                <input
                  type="date"
                  className="form-control"
                  name="fromDateCSV"
                  placeholder="From Date"
                  value={values?.fromDateCSV}
                  onChange={inputHandler}
                  style={{ width: "100%" }}
                />
              </Box>
              <Box
                sx={{
                  width: "50%",
                  padding: "0 5px",
                  "@media (max-width: 767px)": {
                    width: "100%",
                    padding: "0",
                  },
                }}
              >
                <Typography sx={patientSx.filterSpan}>To</Typography>
                <input
                  type="date"
                  className="form-control"
                  name="toDateCSV"
                  placeholder="To Date"
                  value={values?.toDateCSV}
                  onChange={inputHandler}
                  style={{ width: "100%" }}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={{ padding: "10px 20px" }}>
            <Typography sx={patientSx.filterSpan}>Report Type</Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                margin: "-5px -5px 0",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  padding: "5px 5px 0",
                  "@media (max-width: 767px)": {
                    width: "100%",
                    padding: "5px 0 0",
                  },
                }}
              >
                <DropdownField
                  name="csvType"
                  label="Type"
                  dropDownList={fileExportDropDown[role]}
                  itemFieldValue="_id"
                  itemFieldLabel="name"
                  value={values?.csvType}
                  onChange={inputHandler}
                />
              </Box>
              <Box
                sx={{
                  width: "50%",
                  padding: "5px 5px 0",
                  "@media (max-width: 767px)": {
                    width: "100%",
                    padding: "20px 0 0",
                  },
                }}
              >
                <Button
                  color="alert"
                  type="button"
                  onClick={downloadCSV}
                  sx={{ width: "100%" }}
                >
                  <Download /> Download
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default DownloadPopup;
